export const FOLLOWUP_PLAN_LOAD_SUCCESS = 'FOLLOWUP_PLAN_LOAD_SUCCESS';
export const FOLLOWUP_PLAN_LOAD_FAILURE = 'FOLLOWUP_PLAN_LOAD_FAILURE';
export const FOLLOWUP_PATIENT_NOTIFY_PREFERENCE_LOADED = 'FOLLOWUP_PATIENT_NOTIFY_PREFERENCE_LOADED';
